import React from "react";
import SideBarMenu from "./SideBarMenu";
import { Link } from "react-router-dom";

export default function Header() {
  return (
    <>
      <header className="header">
        <div className="container position-relative">
          <div className="main-header">
            <div className="logo">
              <Link to="/">
                <img
                  src="./assets/images/logo/logo.png"
                  alt="OMICRON GRINDING MACHINES PVT. LTD."
                />
              </Link>
            </div>
            <div className="left-menu">
              <ul id="menu">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <h6>Company</h6>
                  <ul className="menus">
                    <li>
                      <Link to="/aboutus">About Us</Link>
                    </li>
                    <li>
                      <Link to="/infrastructure">Infrastructure - R&D</Link>
                    </li>
                    <li>
                      <Link to="/mission-achievements">
                        Mission & Achievements
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <h6>Products</h6>
                  <ul className="menus">
                    <li className="has-submenu">
                      <Link to="#">Centerless Grinding Machine</Link>
                      <ul className="submenu">
                        <li>
                          <Link to="#">Centerless Grinding Machine</Link>
                        </li>
                        <li>
                          <Link to="#">Cylindrical Grinding Machine</Link>
                        </li>
                        <li>
                          <Link to="#">Internal Grinding Machines</Link>
                        </li>
                        <li>
                          <Link to="#">Angular Grinding Machine</Link>
                        </li>
                        <li>
                          <Link to="#">SPM Grinding Machine</Link>
                        </li>
                      </ul>
                    </li>
                    <li className="has-submenu">
                      <li>
                        <Link to="#">Cylindrical Grinding Machine</Link>
                      </li>
                      <ul className="submenu">
                        <li>
                          <Link to="#">Centerless Grinding Machine</Link>
                        </li>
                        <li>
                          <Link to="#">Cylindrical Grinding Machine</Link>
                        </li>
                        <li>
                          <Link to="#">Internal Grinding Machines</Link>
                        </li>
                        <li>
                          <Link to="#">Angular Grinding Machine</Link>
                        </li>
                        <li>
                          <Link to="#">SPM Grinding Machine</Link>
                        </li>
                      </ul>
                    </li>
                    <li className="has-submenu">
                      <Link to="#">Internal Grinding Machine</Link>
                      <ul className="submenu">
                        <li>
                          <Link to="#">Centerless Grinding Machine</Link>
                        </li>
                        <li>
                          <Link to="#">Cylindrical Grinding Machine</Link>
                        </li>
                        <li>
                          <Link to="#">Internal Grinding Machines</Link>
                        </li>
                        <li>
                          <Link to="#">Angular Grinding Machine</Link>
                        </li>
                        <li>
                          <Link to="#">SPM Grinding Machine</Link>
                        </li>
                      </ul>
                    </li>
                    <li className="has-submenu">
                      <li>
                        <Link to="#">Angular Grinding Machine</Link>
                      </li>
                      <ul className="submenu">
                        <li>
                          <Link to="#">Centerless Grinding Machine</Link>
                        </li>
                        <li>
                          <Link to="#">Cylindrical Grinding Machine</Link>
                        </li>
                        <li>
                          <Link to="#">Internal Grinding Machines</Link>
                        </li>
                        <li>
                          <Link to="#">Angular Grinding Machine</Link>
                        </li>
                        <li>
                          <Link to="#">SPM Grinding Machine</Link>
                        </li>
                      </ul>
                    </li>
                    <li className="has-submenu">
                      <Link to="#">SPM Grinding Machine</Link>
                      <ul className="submenu">
                        <li>
                          <Link to="#">Centerless Grinding Machine</Link>
                        </li>
                        <li>
                          <Link to="#">Cylindrical Grinding Machine</Link>
                        </li>
                        <li>
                          <Link to="#">Internal Grinding Machines</Link>
                        </li>
                        <li>
                          <Link to="#">Angular Grinding Machine</Link>
                        </li>
                        <li>
                          <Link to="#">SPM Grinding Machine</Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/contactus">Contact Us</Link>
                </li>
              </ul>
            </div>

            <a className="menu-btn show_sidebar" href="#">
              <i className="fa fa-bars"></i>
            </a>
          </div>
        </div>
      </header>

      <SideBarMenu />
    </>
  );
}
